import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./StartScreen.css";
import useAudio from "./useAudio";
import { mapScore } from "../../utils/mapScore";
import Gallery from "../Gallery/Gallery";
import { trackEvent, EVENT_CATEGORIES, EVENT_ACTIONS } from "../../utils/analytics";

// Helper function to detect if device has touch support (mobile)
const isMobileDevice = () => {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
};

const SupportModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="Support-overlay" onClick={onClose}>
      <div className="Support-content" onClick={e => e.stopPropagation()}>
        <button className="Support-close" onClick={onClose}>×</button>
        <h2 className="Support-title">Support Flappy Trump</h2>
        <p className="Support-description">
          Help us keep making America great again! Your support helps maintain and improve the game.
        </p>
        <div className="Support-wallet">
          ETH: 0xDb10922FE4e4887a2fb6e4d82DBB9e04479d3ECB
        </div>
        <p className="Support-description">
          You can also support us on Patreon buy buying one of your high quality illustrations!
        </p>
        <a 
          href="https://www.patreon.com/rustycreator/shop" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="Support-link"
        >
          Support on Patreon
        </a>
      </div>
    </div>
  );
};

const StartScreen = ({ playing }) => {
  const [showGallery, setShowGallery] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const [audioDisabled, setAudioDisabled] = useState(false);
  const {
    ready, unlock, play, pause, stop
  } = useAudio(require('../../assets/favorite_word.mp3'), { volume: 0.8, loop: true });

  useEffect(() => {
    if (ready && playing && !audioDisabled) {
      play()
    } else if(ready && !playing) {
      stop()
    }
  }, [ready, playing, audioDisabled])

  const enableAudio = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAudioDisabled(false);
    unlock();
    trackEvent(EVENT_CATEGORIES.AUDIO, EVENT_ACTIONS.ENABLE);
  }
  const disableAudio = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAudioDisabled(true);
    trackEvent(EVENT_CATEGORIES.AUDIO, EVENT_ACTIONS.DISABLE);
  }

  const renderInstructionText = () => {
    if (isMobileDevice()) {
      return (
        <p className="StartScreen-start-text">
          Touch the screen to survive the storyline
        </p>
      );
    }
    return (
      <p className="StartScreen-start-text">
        Press
        <img src={require('../../assets/space.png')} alt="space" />
        to survive the storyline
      </p>
    );
  };

  return (
    <>
      {!playing && (
        <div className="StartScreen-overlay">
          <div className="StartScreen-start">
            <img className="StartScreen-image" src={require('../../assets/flappy_trump_cleaned.png')} alt="flappy trump" />

            {renderInstructionText()}
            <div className="StartScreen-action-row">
              {(!ready || audioDisabled) ? (
                <button onClick={enableAudio}>
                  🎧 Enable Audio
                </button>
              ) : (
                <button onClick={disableAudio}>
                  🎧 Disable Audio
                </button>
              )}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGallery(true);
                  trackEvent(EVENT_CATEGORIES.GALLERY, EVENT_ACTIONS.CLICK, 'open_gallery');
                }}
                className="StartScreen-gallery-button"
              >
                📖 Story Gallery
              </button>
            </div>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowSupport(true);
                trackEvent(EVENT_CATEGORIES.SUPPORT, EVENT_ACTIONS.CLICK, 'open_support');
              }}
              className="StartScreen-support-button"
            >
              💰 Support the cause
            </button>
          </div>
        </div>
      )}
      <Gallery isOpen={showGallery} onClose={() => {
        setShowGallery(false);
        trackEvent(EVENT_CATEGORIES.GALLERY, EVENT_ACTIONS.CLICK, 'close_gallery');
      }} />
      <SupportModal isOpen={showSupport} onClose={() => {
        setShowSupport(false);
        trackEvent(EVENT_CATEGORIES.SUPPORT, EVENT_ACTIONS.CLICK, 'close_support');
      }} />
    </>
  );
};

const mapStateToProps = ({ Pipe, Game }) => {
  return {
    score: mapScore(Pipe),
    playing: Game.status === "playing"
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StartScreen);
